import React from 'react';
import AltIso from 'alt/utils/AltIso';
import _ from 'lodash';
import CreateShiftHeader from '../components/CreateShiftHeader';
import CreateShiftStep1 from '../components/CreateShiftStep1';
import CreateShiftStep2 from '../components/CreateShiftStep2';
import CreateShiftStep3 from '../components/CreateShiftStep3';

import SeoActions from '../actions/SeoActions';
import connectToStores from 'alt/utils/connectToStores';
import withRouter from '../utils/with-router';

import ShiftStore from '../stores/ShiftStore';
import ShiftActions from '../actions/ShiftActions';

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Create a new shift');
            resolve();
        }),
        ShiftActions.clearCreation()
    ]);
})
@connectToStores
@withRouter
class CreateShift extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 1,
            lastCompletedStep: 1,
            completeForDraft: false,
            formData: {}
        };
    }

    static getPropsFromStores() {
        return {
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore];
    }

    componentWillReceiveProps(nextProps) {
        const createError = nextProps.shiftStore.createError;
        if (createError.errors && Object.keys(createError.errors).filter(x => x.indexOf('generic') >= 0)) {
            this.setState({activeStep: 1});
        }
    }

    saveDraft() {
        let errors = {};
        if (Object.keys(errors).length > 0 || typeof errors == typeof undefined) {
            ShiftActions.mergeErrorsIntoState(errors);
        } else {
            ShiftActions.saveDraft(this.state.formData, 0, this.context.router);
        }
    }

    formOnChange(formData) {
        let curData = this.state.formData;
        curData = _.merge({}, curData, formData);
        const newState = {formData: curData};
        if (curData.venue &&
            curData.start_date &&
            curData.start_time &&
            curData.end_time ) {
            newState.completeForDraft = true;
        } else {
            newState.completeForDraft = false;
        }
        this.setState(newState);
    }

    shiftHeaderClick(i, force) {
        const lastCompletedStep = this.state.lastCompletedStep;
        if (force || i < lastCompletedStep) return this.setState({activeStep: i, lastCompletedStep: i > this.state.lastCompletedStep ? i : lastCompletedStep});
        if (this.state.activeStep == 1 && _.keys(this.props.shiftStore.stepOneData).length < 4 && i > 1) return;
        if (this.state.activeStep == 2 && _.keys(this.props.shiftStore.stepTwoData).length < 2 && i > 2) return;
        this.setState({
            activeStep: i,
            lastCompletedStep: i > this.state.lastCompletedStep ? i : lastCompletedStep
        });
    }

    render() {
        return (
            <div className="view-create-shift">
                <CreateShiftHeader completed={this.state.completeForDraft} saveDraft={this.saveDraft.bind(this)} canCancel={this.props.shiftStore.shiftCount > 0} />

                <div className="view-content maxwidth-wrapper">

                    <div className="whitebox">
                        <div className={"create-shift-step" + (this.state.activeStep == 1 ? " active" : "")}>

                            <button onClick={this.shiftHeaderClick.bind(this, 1, false)} className="create-shift-step-header">
                                <span className="step-nr">1</span>
                                <h2 className="step-title">Shift details</h2>
                            </button>

                            <CreateShiftStep1 user={this.props.user.profile.profile} onChange={this.formOnChange.bind(this)} createShiftDate={this.props.shiftStore.createDate} changeStep={this.shiftHeaderClick.bind(this)} />
                        </div>

                        <div className={"create-shift-step" + (this.state.activeStep == 2 ? " active" : "")}>

                            <button disabled={this.state.lastCompletedStep >= 2 ? false : true} onClick={this.shiftHeaderClick.bind(this, 2, false)} className="create-shift-step-header">
                                <span className="step-nr">2</span>
                                <h2 className="step-title">Position</h2>
                            </button>

                            <CreateShiftStep2 onChange={this.formOnChange.bind(this)} changeStep={this.shiftHeaderClick.bind(this)} />
                        </div>

                        <div className={"create-shift-step" + (this.state.activeStep == 3 ? " active" : "")}>

                            <button disabled={this.state.lastCompletedStep >= 3 ? false : true} onClick={this.shiftHeaderClick.bind(this, 3, false)} className="create-shift-step-header">
                                <span className="step-nr">3</span>
                                <h2 className="step-title">{"Finish up & Publish"}</h2>
                            </button>

                            <CreateShiftStep3 saveDraft={this.saveDraft.bind(this)} onChange={this.formOnChange.bind(this)} changeStep={this.shiftHeaderClick.bind(this)} user={this.props.user.profile} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreateShift;



/** WEBPACK FOOTER **
 ** ./app/src/views/CreateShift.js
 **/